"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Timer = void 0;
var Timer = (function () {
    function Timer(config) {
        this.start = Date.now();
        this.labelMap = {};
        if (config.start) {
            this.start = config.start;
        }
        if (config.labelMap) {
            this.labelMap = config.labelMap;
        }
        this.histogram = config.histogram;
    }
    Timer.prototype.observeDuration = function () {
        var end = Date.now();
        var diff = end - this.start;
        this.histogram.observe(diff / 1000, this.labelMap);
    };
    return Timer;
}());
exports.Timer = Timer;
//# sourceMappingURL=Timer.js.map